package com.mrpowergamerbr.puppydough

import web.dom.ParentNode
import web.dom.TagName
import web.dom.document
import web.html.HTMLElement

inline fun <T : HTMLElement> ParentNode.el(
    tag: TagName<T>,
    block: T.() -> Unit = {},
): T = document.createElement(tag).apply(block).also { append(it) }